const k = [
  "data-track-ga-event-trigger",
  "data-track-ga-event-category",
  "data-track-ga-event-action",
  "data-track-ga-event-label",
  "data-track-ga-event-value"
], s = (a) => k.some((t) => a[t] !== void 0), v = (a) => {
  const { autoTrackingKey: t, props: c, source: e = "element", trigger: r = "click", category: n, action: g } = a, o = n || `${e} autoTracking`, i = g || `${e} ${r}`;
  return s(c) ? {} : !t || t.trim() === "" ? {} : {
    "data-track-ga-event-trigger": r,
    "data-track-ga-event-category": o,
    "data-track-ga-event-action": i,
    "data-track-ga-event-label": t
  };
};
export {
  v as getAutoTrackingAttributes
};
//# sourceMappingURL=autoTracking.js.map
